/** When your routing table is too long, you can split it into small modules **/

import Layout from '@/layout'

const inspection = {
  path: '/inspection',
  component: Layout,
  redirect: '/inspection',
  name: 'Inspection',
  meta: {
    title: 'inspection',
    icon: 'zijinrizhi',
    perm: 'cInspectionManager'
  },
  children: [
    {
      path: 'inspection-person',
      component: () => import('@/views/inspection/inspection-person/index.vue'),
      name: 'InspectionPerson',
      meta: {
        title: 'inspectionPerson',
        perm: 'cInspectionPersonManager'
      }
    },
    {
      path: 'inspection-device',
      component: () => import('@/views/device/face-recognition/index.vue'),
      name: 'InspectionDevice',
      meta: {
        title: 'inspectionDevice',
        perm: 'cInspectionDeviceManager',
        isRecorder: true
      }
    },
    {
      path: 'inspection-record',
      component: () => import('@/views/inspection/face-record/index.vue'),
      name: 'InspectionRecord',
      meta: {
        title: 'inspectionRecord',
        perm: 'cInspectionRecord',
        isRecorder: true
      }
    }
  ]
}
export default inspection
